<!-- Young -->
<template>
  <div class='account-ec'>
    <public-bread-crumb :routes='routes'></public-bread-crumb>
    <div class="content-wrap">
      <p class="page-title">{{ title }}</p>
      <div class="from-wrap">
        <a-spin :spinning="formLoading">
          <a-form :form="formData" style="width: 100%;">
            <a-row>
              <a-col :span="10" :offset="1">
                <a-form-item label="用户真实姓名" :labelCol="{span: 10}" :wrapperCol="{span: 14}" required>
                  <a-input
                    placeholder="请输入用户姓名"
                    class="item-input"
                    v-decorator="[
                      'userName',
                      {
                        validateTrigger: 'blur',
                        rules: [
                          { validator: checkUsreName }
                        ]
                      }
                    ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="10">
                <a-form-item label="手机号码" :labelCol="{span: 10}" :wrapperCol="{span: 14}" required>
                  <a-input
                    placeholder="请输入此账号人员手机号码"
                    class="item-input"
                    v-decorator="[
                      'userPhone',
                      {
                        validateTrigger: 'blur',
                        rules: [{ validator: checkPhone }]
                      }
                    ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="10" :offset="1">
                <a-form-item label="密码" :labelCol="{span: 10}" :wrapperCol="{span: 14}" required>
                  <a-input
                    placeholder="请输入密码"
                    class="item-input"
                    v-decorator="[
                      'pwd1',
                      {
                        validateTrigger: 'blur',
                        rules: [{ validator: firstCheckPwd }]
                      }
                    ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="10">
                <a-form-item label="再次输入密码" :labelCol="{span: 10}" :wrapperCol="{span: 14}" required>
                  <a-input
                    placeholder="请再次输入密码"
                    class="item-input"
                    v-decorator="[
                      'pwd2',
                      { validateTrigger: 'blur', rules: [{ validator: againCheckPwd }] }
                    ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <div class="btn-wrap">
                  <a-button type="primary" class="tool-btn" style="margin-right: 32px;" @click="handleSubmit" :loading="btnLoading">保存</a-button>
                  <a-button class="tool-btn" style="color: #5862CB; background: #ECEDFF;" @click="$router.push('/system/account')">取消</a-button>
                </div>
              </a-col>
            </a-row>
          </a-form>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import accountService from '@/services/account.services'

export default {
  name: 'AccountEC',
  inject: ['reload'],
  data () {
    return {
      title: '新增账号',
      formData: this.$form.createForm(this, { name: 'accountForm' }),
      pwdReg: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
      id: '',
      btnLoading: false,
      formLoading: false,
      oldUserPhone: ''
    }
  },
  computed: {
    // 监听属性 类似于data概念
    routes () {
      return [
        {
          name: '账号管理',
          path: '/system/account'
        },
        {
          name: this.title,
          path: ''
        }
      ]
    }
  },
  mounted () {
    /*
      编辑模式
      >>根据传入的ID,调接口获得表单的数据
      >>通过setFieldsValue({控件的id名: 控件对应的表单数据}),回填数据
      >>例子：this.formData.setFieldsValue({userName: '张三'})
    */
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.getInfo()
      this.title = '编辑账号'
    }
  },
  methods: {
    // 用户真实姓名检验
    checkUsreName (rule, value, callback) {
      // let val = value.trim()
      // this.formData.setFieldsValue({
      //   userName: val
      // })
      let reg = /^[0-9A-Za-z\s\u4e00-\u9fa5]{1,64}$/
      if (!value) {
        callback(new Error('请填写用户姓名'))
      } else if (value && !reg.test(value)) {
        callback(new Error('用户姓名长度需在1~64位'))
      } else {
        callback()
      }
    },

    // 电话校验
    async checkPhone (rule, value, callback) {
      let reg = /^1[345789][0-9][0-9]\d{7}$/
      if (value && !reg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else if (!value) {
        callback(new Error('请填写该用户手机号码'))
      } else {
        callback()
      }
    },

    // 第一遍密码校验
    firstCheckPwd (rule, value, callback) {
      let reg = /^[0-9A-Za-z_!@#$%^&*()]{8,16}$/
      // let reg2 = /^[^\s]*$/g
      if (value && !reg.test(value)) {
        callback(new Error('请填写8~16密码'))
      } else if (!value) {
        callback(new Error('请填写8~16密码'))
      } else {
        callback()
      }
    },

    // 第二遍密码校验
    againCheckPwd (rule, value, callback) {
      let reg = /^[0-9A-Za-z_!@#$%^&*()]{8,16}$/
      const form = this.formData
      if (value && value !== form.getFieldValue('pwd1')) {
        callback(new Error('两次密码输入不一致!'))
      } else if (!value || (value && !reg.test(value))) {
        callback(new Error('请填写8~16密码'))
      } else {
        callback()
      }
    },

    // 获取设备详细数据
    async getInfo () {
      this.formLoading = true
      let res = await accountService.GetInfo({ id: this.id })
      this.formLoading = false
      if (res.status === 0) {
        this.formData.setFieldsValue({
          userName: res.result.name,
          userPhone: res.result.account,
          pwd1: res.result.password,
          pwd2: res.result.password
        })
        this.oldUserPhone = res.result.account
      }
    },

    /**
    * 提交表单
    */
    handleSubmit (e) {
      e.preventDefault()
      this.formData.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          let res
          this.btnLoading = true
          if (this.id) {
            res = await accountService.UpdateAccount({
              id: this.id,
              name: values.userName,
              account: values.userPhone,
              password: values.pwd1
            })
          } else {
            res = await accountService.AddAccount({
              name: values.userName,
              account: values.userPhone,
              password: values.pwd1
            })
          }
          this.btnLoading = false
          if (res.status === 0) {
            let desc = ''
            if (this.id) {
              let oldUser = window.sessionStorage.getItem('username')
              if (this.oldUserPhone === oldUser) {
                window.sessionStorage.setItem('username', values.userPhone)
              }
              this.reload()
              desc = '修改成功'
            } else {
              desc = '添加成功'
            }
            this.notification('success', '成功', desc)
            this.$router.push('/system/account')
          }
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .account-ec {
    .content-wrap {
      height: 540px;
      margin: 0 16px 16px;
      padding: 24px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      .page-title {
        font-size: 18px;
        color: #5862CB;
        // margin-bottom: 140px !important;
      }
      .from-wrap {
        padding: 120px 12%;
        flex: 1;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        .item-input {
          max-width: 296px;
          // margin-left: 10px;
        }
        .btn-wrap {
          display: flex;
          justify-content: center;
          align-items: center;
          .tool-btn {
            width:88px;
            height:32px;
            border-radius:3px;
          }
        }
      }
    }
  }
</style>
